/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

// import { startIdentityLogin } from '../../redux/identity/identity-actions';
import layoutSizes from '../../utils/layoutSizes';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import Toast from '../common/Toast';

function LayoutMain({ children }: { children: React.ReactNode }) {
 const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(
  localStorage.getItem('sidebar_open') === 'true',
 );
 useEffect(() => {
  localStorage.setItem('sidebar_open', isSidebarOpen.toString());
 }, [isSidebarOpen]);

 return (
  //   <Auth>
  <Box
   sx={{
    height: '100%',
    width: isSidebarOpen
     ? { xs: '100%', md: `calc(100% - ${layoutSizes.sidebarWidth}px)` }
     : { xs: '100%', md: 'calc(100% - 76px)' },
    ml: isSidebarOpen
     ? { xs: 0, md: `${layoutSizes.sidebarWidth}px` }
     : { xs: 0, md: '76px' },
    pt: `${layoutSizes.headerHeight}px`,
   }}
  >
   <Box sx={{ height: '100%' }}>
    <Sidebar
     isSidebarOpen={isSidebarOpen}
     setIsSidebarOpen={setIsSidebarOpen}
    />
    <Header isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
    <Box
     component="main"
     sx={{
      flexGrow: 1,
      bgcolor: 'background.default',
      p: 3,
      height: '100%',
     }}
    >
     {children}
    </Box>
   </Box>
   {/* <Footer /> */}
   <Toast />
  </Box>
  //   </Auth>
 );
}
export default LayoutMain;
